let installed = false;
let onExpired: (() => void) | null = null;

/**
 * Calls `callback` when a backend API request returns 401, e.g. after the
 * Keycloak session ended. Pass null to stop.
 */
export default function handleSessionExpiry(
  apiUrl: string,
  callback: (() => void) | null,
) {
  onExpired = callback;
  if (installed) {
    return;
  }
  installed = true;
  const originalFetch = window.fetch;
  window.fetch = async (...args: Parameters<typeof fetch>) => {
    const response = await originalFetch(...args);
    const [input] = args;
    const url =
      input instanceof Request ? input.url : (input as string | URL).toString();
    if (response.status === 401 && onExpired && url.startsWith(apiUrl)) {
      onExpired();
    }
    return response;
  };
}
